export default function formatAddress(address) {
  // Check if all main address fields are present and non-empty
  const hasMainFields = [
    address?.addressLineOne,
    address?.addressLineTwo,
    address?.city,
    address?.state,
  ].every((part) => part && part.toString().trim() !== '');

  const parts = [
    address?.unitNo,
    address?.addressLineOne,
    address?.addressLineTwo,
    address?.city,
    address?.state,
    address?.pinCode,
  ];

  // Only add country if all main fields are present
  if (hasMainFields) {
    parts.push(address?.country);
  }

  return parts.filter((part) => part && part.toString().trim() !== '').join(', ');
}
